import { useDoneRedirect } from '../../../hooks/useDoneRedirect';
import { type DonePageProps } from '../../../chulak/ChulakSession';
import EmbeddedErrorScreen from './ErrorScreen';
import EmbeddedStatusScreen from './StatusScreen';
import EmbeddedSpinnerScreen from './SpinnerScreen';
import { useEmbeddedCopy } from '../../../hooks/useEmbeddedCopy';

/**
 * Done: the result goes to the website's backend through the webhook. A
 * spinner until Ronan has handed it over, so "Shared" is only said once it is
 * true. The card stays on this screen until the website removes it.
 */
export default function EmbeddedDonePage({
  app,
  onComplete,
  continueInApp,
}: DonePageProps) {
  const { t, pick } = useEmbeddedCopy();
  const { error, done, handleManualComplete } = useDoneRedirect(
    onComplete,
    continueInApp,
    'webhook',
  );

  if (error)
    return <EmbeddedErrorScreen app={app} onRetry={handleManualComplete} />;
  if (!done) return <EmbeddedSpinnerScreen />;

  return (
    <EmbeddedStatusScreen
      visual="app"
      app={app}
      badge="check"
      title={t(pick('embedded.done.title', 'embedded.done.titleIssuance'), {
        app: app?.name ?? '',
      })}
      sub={t(pick('embedded.done.sub', 'embedded.done.subIssuance'))}
    />
  );
}
